import { render, staticRenderFns } from "./classperformance.vue?vue&type=template&id=0e714429&"
import script from "./classperformance.vue?vue&type=script&lang=js&"
export * from "./classperformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports